var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{attrs:{"type":"text","autocomplete":_vm.schema.autocomplete,"disabled":_vm.disabled,"placeholder":_vm.schema.placeholder,"readonly":_vm.schema.readonly,"name":_vm.schema.inputName,"id":_vm.getFieldID(_vm.schema)}})}
var staticRenderFns = []

export { render, staticRenderFns }